import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import router from '../../../router/index.js';
import Md5 from 'js-md5';
const vm = new Vue();

const baseUrl = 'http://teacheradminapi.vstrain.cn';
// const baseUrl = 'http://teacheradminapitest.vstrain.cn';
// const baseUrlAdmin = 'http://adminapitest.vstrain.cn';
const baseUrlAdmin = 'http://adminapi.vstrain.cn';
// const rgzUrl = 'http://www.rgzcloud.com';

console.log(qs);
console.log(router);
console.log(vm);
// console.log(rgzUrl);

axios.interceptors.response.use((res) => {
	// console.log("请求地址：" + res)
	// console.log(res.data)
	// console.log(JSON.parse(res.data));
	// return (JSON.parse(res.data));
	console.log(res);
	if (res.data.hasOwnProperty.call(res.data, 'code') && res.data.code != 0) {
		vm.$message({
			message: res.data.ret,
			type: 'warning',
			offset: 100,
		});

	}
	if (res.data.ret == 'token值过期') {
		localStorage.removeItem('storage');
		localStorage.removeItem('session');
		localStorage.removeItem('token');
		location.href = '/';
		// vm.$router.push('/');
	} else {
		return res.data;
	}
});

// 后台上线出问题，排除是否为接口问题放到前端进行简单测试请求一下
// export const requestTest = () => {
//     return axios({
//         url: baseUrl + "/admin_activity/activity"
//     })
// }
let Signappid = 'vstrainsign';
let appversion = '5.0.1';
let Signappsercet = 'vstrainsercet!@#$';
export const token = () => {
	const token = localStorage.getItem('token');
	if (token == null) {
		// this.$router.push({ path: '' });
		location.href = '/';
		// this.$router.push({ path: '/' });
	}
	return token;
};
export const autograph = (data) => {
	if (data.sign) {
		delete data.sign
	}

	let singMD5 = Signappid + appversion + Signappsercet + JSON.stringify(data);

	return Md5(singMD5);

}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, data = {}) {
	return new Promise((resolve, reject) => {
		data.token = token();
		data.sign = autograph(data);
		axios.get(url, {
				params: {
					data: JSON.stringify(data),
					page: data.currentPage
				}
			})
			.then(response => {
				resolve(response)
			}, err => {
				reject(err)
			})
			.catch((error) => {
				reject(error)
			})
	});
}

/**
 * 封装post请求，主要用于添加资源
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		data.token = token();
		data.sign = autograph(data);
		axios.post(url, {
				data: JSON.stringify(data)
			}, {
				contentType: 'application/json;charset=UTF-8'
			})
			.then(response => {
				resolve(response);
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	});
}

// 登录
export const Login = (data) => {
	// data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/account_login?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};
// 登出
export const account_logout = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/account_logout?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};
// 课程管理
export const trainorder_list = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/trainorder_list?data=${JSON.stringify(data)}` + "&page=" + page,
		method: 'GET',
	});
};
//用户管理-账号管理-新增用户    机构/院校  的远程搜索
export const Remotesearch = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/organization_list?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};
export const config_organization_course_get_list = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_organization_course_get_list?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};
export const config_organization_course_add_edit = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_organization_course_add_edit?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};




export const organization_course_config_relation_add = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/organization_course_config_relation_add?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};
export const organization_course_config_relation_delete = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/organization_course_config_relation_delete?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};

export const config_organization_nav_edit = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_organization_nav_edit`,
		method: 'POST',
		data:{
			data:`${JSON.stringify(data)}`
		}
	});
};
export const config_organization_nav_list = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_organization_nav_list?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};

// 教师列表
export const account_teacher_list = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/account_teacher_list?data=${JSON.stringify(data)}` + "&page=" + page,
		method: 'GET',
	});
};
// 教师审核
export const account_teacher_audit = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/account_teacher_audit?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};
// 教师移除
export const account_teacher_remove = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/account_teacher_remove?data=${JSON.stringify(data)}`,
		method: 'POST',
	});
};
// 证书查看-教师管理员授权证书获取
export const trainorder_certlist = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/trainorder_certlist?data=${JSON.stringify(data)}` + "&page=" + page,
		method: 'GET',
	});
};
// 产品管理-教师管理员产品管理
export const TrainorderList = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/trainorder_list?data=${JSON.stringify(data)}` + "&page=" + page,
		method: 'GET',
	});
};

// 院校logo
export const organizationLogo = (data, page) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrl}/organization_logo?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};

//系统配置-院校登陆配置列表
export const ConfigLoginList = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_login_list?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};

//系统配置-院校登陆配置增加
export const ConfigLoginAdd = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_login_add`,
		method: 'POST',
		data: {
			data: `${JSON.stringify(data)}`
		}
	});
};

//系统配置-院校登陆配置修改
export const ConfigLoginEdit = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/config_login_edit`,
		method: 'POST',
		data: {
			data: `${JSON.stringify(data)}`
		}
	});
};

//文件上传获取oss信息
export const GetUploadKey = (data) => {
	data.token = token();
	data.sign = autograph(data);
	return axios({
		url: `${baseUrlAdmin}/meta_getuploadkey?data=${JSON.stringify(data)}`,
		method: 'GET',
	});
};
